import { ref, computed } from 'vue'
import { useHttp } from '@core/composables/useHttp'
import API from '@core/api.js'

const packageGroups = ref(null)

const hasPackageGroupPackages = computed(() => {
  if (!packageGroups.value?.data?.length) return false

  return packageGroups.value.data.some((group) => group.packages?.length > 0)
})

const { data, isLoading, execute } = useHttp({ showErrorToast: false })

const getPackageGroups = () =>
  execute({ url: API.packageGroupsResource }, () => {
    packageGroups.value = data.value
  })

const usePackageGroups = () => ({
  packageGroups,
  hasPackageGroupPackages,
  isPackageGroupsLoading: isLoading,
  getPackageGroups,
})

export { usePackageGroups }
